import React from "react"
import { useSelector } from "react-redux"
import BlockFormModal from "./components/blockFormModal"
import BlockDialog from "./components/blockDialog"
import BlockCard from "../../../../../../../../../../../../components/v2/layout/cards/blockCard"
import SuperListPage from "../../../../../../../../../../../../components/v2/layout/superListPage/superListPage"
import { SEGMENTS } from "../../../../../../../../../../../../library/store/actions/types/groupsTypes"
import { useIdParam } from "../../../../../../../../../../../../hooks/useIdParam"
import { useBlockMutations } from "../../../../../../../../../../../../hooks/data/calendar/schedules"

const SegmentSectionBlocks = () => {
  const section_id = useIdParam("sectionId")

  const { sectionBlocksList, sectionBlocksListEndReached } = useSelector(
    ({ groups }) => groups
  )

  const queryKey = [SEGMENTS.SECTIONS.BLOCKS.LIST, { section_id }]

  const { deleteBlock } = useBlockMutations(queryKey)

  return (
    <SuperListPage
      headerProps={{
        title: "Section Blocks",
        button: { label: "Create Block" },
      }}
      listItemHeight={103}
      noResultsLabel={"This section doesn't have blocks yet"}
      queryConfig={{
        key: queryKey,
        fetchParams: {
          section_id,
        },
        listKey: "blocks",
      }}
      getListItemComponent={({
        item,
        openEditDialog,
        openDeletionDialog,
        openInfoDialog,
      }) => (
        <BlockCard
          block={item}
          openDeleteBlock={openDeletionDialog}
          openEditBlock={openEditDialog}
          openBlockDetails={openInfoDialog}
          key={item.id}
        />
      )}
      getFormDialogComponent={({ open, onClose, activeItem }) => {
        return (
          <BlockFormModal
            open={open}
            onClose={onClose}
            activeBlock={activeItem}
            queryKey={queryKey}
          />
        )
      }}
      getDeletionDialogComponent={{
        entityName: "block",
        onDelete: (id) => deleteBlock.mutateAsync({ id }),
      }}
      getInfoDialogComponent={({ open, onClose, activeItem }) => (
        <BlockDialog open={open} onClose={onClose} activeBlock={activeItem} />
      )}
    />
  )
}

export default SegmentSectionBlocks
